import moment from 'moment';

export const dateFormat = (inputDateString, dateOnly = false, dateProtector = false) => {
  if (!inputDateString) return '';

  const inputDate = new Date(inputDateString);

  // dateProtector: the value is a business date with no meaningful time-of-day
  // (e.g. delivery/mailed/effective date), stored as a UTC-midnight instant.
  // Read its UTC calendar day so every viewer sees the same date regardless of
  // their own timezone, instead of letting toLocaleString() re-localize it.
  const displayDate = dateProtector
    ? new Date(inputDate.getUTCFullYear(), inputDate.getUTCMonth(), inputDate.getUTCDate())
    : inputDate;

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: dateOnly ? undefined : '2-digit',
    minute: dateOnly ? undefined : '2-digit',
    hour12: dateOnly ? false : true,
  };

  return displayDate.toLocaleString('en-US', options);
};

export const formatCallDuration = (duration) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  if (hours > 0) {
    // Format as h:mm:ss (with leading zeros for minutes and seconds)
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  } else if (minutes > 0) {
    // Format as m:ss (with leading zero for seconds)
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  } else {
    // Format as XXs (only seconds)
    return `${seconds}s`;
  }
};

// Formats a Date using its local year/month/day (no UTC conversion, unlike toISOString()).
export const formatDateOnly = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Parses a "YYYY-MM-DD" string as local midnight (unlike new Date(str), which parses it as UTC midnight).
export const parseLocalDateOnly = (dateOnlyString) => {
  const [year, month, day] = dateOnlyString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const dateProtector = (update) => {
  if (Array.isArray(update)) {
    if (update[0] !== null && update[1] !== null) {
      update[0].setHours(12);
      update[1].setHours(12);
    }
  } else if (update) {
    update.setHours(12);
  }
  return update;
};

export const getTimeOnly = (inputDateString) => {
  const inputDate = new Date(inputDateString);

  const options = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };

  return inputDateString ? inputDate.toLocaleString('en-US', options) : null;
};

export const giveDaysUptilNow = (inputDateString) => {
  const inputDate = new Date(inputDateString);
  const now = new Date();
  const diff = now - inputDate;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  return days;
};

export function doesItFallInCancellationPeriod(deliveryDate) {
  const currentDate = moment();
  const scheduledDate = moment(deliveryDate);
  const isScheduledDayArrived = scheduledDate.isBefore(currentDate);
  const dayOfWeek = currentDate.day();
  const allowedDays = [1, 3, 5];
  if (moment(scheduledDate).isSame(currentDate, 'day')) {
    return true;
  }
  return !isScheduledDayArrived || (isScheduledDayArrived && !allowedDays.includes(dayOfWeek));
}

export const isValidDate = (dateString) => {
  let dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})( (\d{1,2}):(\d{2}):(\d{2}))?$/;

  if (!dateRegex.test(dateString)) {
    return false;
  }

  let [, month, day, year, time] = dateString.match(dateRegex);

  let date = new Date(year, month - 1, day);
  if (
    date.getFullYear() != year ||
    date.getMonth() + 1 != month ||
    date.getDate() != day ||
    date.getFullYear() < 1000 ||
    date.getFullYear() > 9999
  ) {
    return false;
  }

  if (time) {
    var [hours, minutes, seconds] = time.split(':');
    if (
      isNaN(hours) ||
      isNaN(minutes) ||
      isNaN(seconds) ||
      hours < 0 ||
      hours > 23 ||
      minutes < 0 ||
      minutes > 59 ||
      seconds < 0 ||
      seconds > 59
    ) {
      return false;
    }
  }

  return true;
};

export const dateFromString = (dateString) => {
  let dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})( (\d{1,2}):(\d{2}):(\d{2}))?$/;

  if (!dateRegex.test(dateString)) {
    return false;
  }

  let [, month, day, year, time] = dateString.match(dateRegex);

  let date = new Date(year, month - 1, day);
  if (
    date.getFullYear() != year ||
    date.getMonth() + 1 != month ||
    date.getDate() != day ||
    date.getFullYear() < 1000 ||
    date.getFullYear() > 9999
  ) {
    return false;
  }

  if (time) {
    var [hours, minutes, seconds] = time.split(':');
    if (
      isNaN(hours) ||
      isNaN(minutes) ||
      isNaN(seconds) ||
      hours < 0 ||
      hours > 23 ||
      minutes < 0 ||
      minutes > 59 ||
      seconds < 0 ||
      seconds > 59
    ) {
      return false;
    }
  }

  return date;
};

export const handleRawChangeForDatePicker = (e, setState) => {
  if (e.target.value) {
    const dates = e.target.value.split(' - ').map((d) => {
      return isValidDate(d) ? d : null;
    });

    if (dates[0] && dates[1]) {
      const datesToUpdate = dates.map((d) => dateFromString(d));
      dateProtector(datesToUpdate);
      setState(datesToUpdate);
    }
  }
};
